<script setup lang="ts">
const { data, pending: _pending, error: _error } = await useInvestigationArticles()

const articles = computed(() => {
  return data.value?.slice(1) || []
})

const container = ref(null)

const swiper = useSwiper(container)

function previous() {
  swiper.instance.value?.slidePrev()
}

function next() {
  swiper.instance.value?.slideNext()
}
</script>

<template>
  <div class="overflow-hidden">
    <ClientOnly>
      <swiper-container
        ref="container"
        class="isolate"
        slides-per-view="auto"
        :navigation="false"
      >
        <swiper-slide
          v-for="article in articles"
          :key="article.id"
          :article="article"
          class="max-w-[30rem] h-auto"
        >
          <div class="h-full">
            <HomeSectionsInvestigationsItemsItem :article="article" />
          </div>
        </swiper-slide>
      </swiper-container>
    </ClientOnly>
    <div class="grid grid-cols-[auto_1fr_auto] border-t border-neutral-200 dark:border-neutral-800">
      <div class="border-r border-neutral-200 dark:border-neutral-800 size-20 flex justify-center items-center">
        <UButton icon="bx:chevron-left" variant="outline" size="xl" @click="previous" />
      </div>
      <div class="flex items-center justify-center">
        <div v-if="swiper.instance.value" class="hidden lg:flex">
          <HomeSectionsInvestigationsItemsBullet
            v-for="(article, index) in articles"
            :key="article.id"
            :index="index"
            :swiper="swiper.instance.value"
          />
        </div>
      </div>
      <div class="border-l border-neutral-200 dark:border-neutral-800 size-20 flex justify-center items-center">
        <UButton icon="bx:chevron-right" variant="outline" size="xl" @click="next" />
      </div>
    </div>
  </div>
</template>
